function SectionHeading({ eyebrow, title, description, light = false, centered = false }) {
  return (
    <div className={`section-heading${light ? ' section-heading-light' : ''}${centered ? ' section-heading-centered' : ''}`}>
      <span className="eyebrow">{eyebrow}</span>
      <h2>{title}</h2>
      {description && <p>{description}</p>}
    </div>
  );
}

export default SectionHeading;
